/** UI-side parsing helpers (the engine has its own display formatting in engine/format.ts). */

/** Lenient number parse: trims, accepts a comma decimal separator, returns null when not a number. */
export function parseNumber(text: string | null | undefined): number | null {
  if (text === null || text === undefined) return null;
  const t = text.trim().replace(",", ".");
  if (t === "") return null;
  if (!/^[-+]?(\d+\.?\d*|\.\d+)([eE][-+]?\d+)?$/.test(t)) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

export function oneDecimal(v: number): string {
  return v.toFixed(1);
}

/** 27.5 → "27.5", 30 → "30". */
export function formatSeconds(s: number): string {
  return Number.isInteger(s) ? s.toFixed(0) : s.toFixed(1);
}
